import { apiService } from '@clarix/api-client';
import { pmsBase } from '../lib/base';
import { PMS_ENDPOINTS } from '../endpoints';
import type {
  PerformanceBand,
  CreateBandPayload,
  UpdateBandPayload,
  ReplaceBandsPayload,
  BandValidationResult,
  ValidateBandsPayload,
} from '../types';

export const bandsApi = {
  list: () =>
    apiService.get<PerformanceBand[]>(`${pmsBase()}${PMS_ENDPOINTS.BANDS}`),

  create: (data: CreateBandPayload) =>
    apiService.post<PerformanceBand>(`${pmsBase()}${PMS_ENDPOINTS.BANDS}`, data),

  /**
   * Replace the WHOLE set in one call (§4).
   *
   * The editor's save path. Bands must tile 20–100 with no gap or overlap, which
   * makes the SET the unit of validity — and the previous save fired one request
   * per changed row through `Promise.all`, so the server saw a series of invalid
   * intermediate states in a non-deterministic order and could not validate any
   * of them. A partial failure also left the ladder half-written.
   */
  replaceAll: (data: ReplaceBandsPayload) =>
    apiService.put<PerformanceBand[]>(`${pmsBase()}${PMS_ENDPOINTS.BANDS}`, data),

  update: (bandId: string, data: UpdateBandPayload) =>
    apiService.put<PerformanceBand>(`${pmsBase()}${PMS_ENDPOINTS.BANDS}/${bandId}`, data),

  delete: (bandId: string) =>
    apiService.delete<void>(`${pmsBase()}${PMS_ENDPOINTS.BANDS}/${bandId}`),

  /** Validate a proposed band set for overlap/gap before saving. */
  validate: (data: ValidateBandsPayload) =>
    apiService.post<BandValidationResult>(`${pmsBase()}${PMS_ENDPOINTS.BANDS_VALIDATE}`, data),
};
